import { OvertimeComponent } from "../../components";

export default function OvertimeSummaryPage() {
  return <OvertimeComponent.OvertimeSummaryList />;
}
